import { createLazyComponent } from 'helpers/createLazyComponent'

const ExaminationSettingsLazy = createLazyComponent(() =>
  import('./ExaminationSettings')
)

export default ExaminationSettingsLazy
